import React from "react"
import { IBanner, ILink } from "../../../gatsby-graphql"
import { Button, Heading } from "../../ui"
import { ButtonType } from "../../ui/button/button-elements"
import { SectionProps } from "../section-loader"
import {
  Background,
  BackgroundWrapper,
  Content,
  ContentButtons,
  ContentDescription,
  ContentWrapper,
  SectionWrapper,
  BannerWrapper,
  BannerTitle
} from "./full-width-banners-elements"

interface FullWidthBannersProps extends SectionProps {
  data: {
    banners?: IBanner[]
  }
}

const FullWidthBanners = ({ data, locale }: FullWidthBannersProps) => {
  let height: number | undefined

  if (!data.banners || data.banners.length <= 0) {
    return <></>
  }

  return (
    <SectionWrapper>
      <BackgroundWrapper>
        {data.banners.map((banner, index) => {
          if (!height || height > (banner?.background?.height || height)) {
            height = banner?.background?.height || height
          }
          return <Background className={banner?.align !== null && banner.align ? banner.align.toLowerCase() : "left"} imgSrc={`${banner?.background?.url as string}`} key={index} />
        })}
      </BackgroundWrapper>
      <ContentWrapper height={height}>
        {data.banners.map((banner, index) => (
          <Content key={index}>
            <BannerWrapper className={banner?.align !== null && banner.align ? banner.align.toLowerCase() : "left"}>
            <BannerTitle>{banner.title}</BannerTitle>
            {banner.description && (
              <ContentDescription>{banner.description}</ContentDescription>
            )}
            {banner.buttons && banner.buttons.length > 0 && (
              <ContentButtons>
                {banner.buttons.map((button, index) => (
                  <Button
                    type={button?.type as ButtonType}
                    link={button?.link as ILink}
                    locale={locale}
                    key={index}
                  >{button?.name}</Button>
                ))}
              </ContentButtons>
            )}
            </BannerWrapper>
          </Content>
        ))}
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default FullWidthBanners
